import React from 'react';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './appInsights';

interface AppInsightsProviderProps {
  children: React.ReactNode;
}

export const AppInsightsProvider: React.FC<AppInsightsProviderProps> = ({ children }) => {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
};